// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"623857ec","732":"8a4f8c97","977":"1a26fe0c"}[chunkId] + ".chunk.js";
};